import React, { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import LayoutOne from "../layouts/LayoutOne";
import PageHeader from '../components/PageHeader'
import SectionTitle from '../components/SectionTitles/SectionTitle';
import ChooseUsList from '../components/WhyChooseUs/ChooseUsList';
import AboutData from "../data/About/about-one";
import AboutDataLocal from "../data/About/about-one-local";
import Seo from '../components/Seo';

const currentUrl = window.location.href;
const isLocal = currentUrl.includes("local.navysealsmoving");
const services = isLocal ? AboutDataLocal : AboutData;

// Same copy the About section has always shown, per site version
const paragraph1 = isLocal
    ? "Navy Seals Moving is a family-owned company with over 20 years of experience, trusted for both local and long-distance moves across the United States. Built on family values and a strong commitment to our community, we deliver a customer-first approach for every move, whether nearby or across the country. We offer a complete range of services to meet the unique needs of each relocation, ensuring that your experience is seamless, efficient, and stress-free."
    : "Navy Seals Moving is a family-owned company with over 20 years of experience, specializing in long-distance moves across the United States. Our foundation of trust and unity, built on family values, enables us to focus entirely on delivering the best for our clients. We provide a full range of services to meet the unique needs of any long-distance move, and our fully insured, bonded, and licensed company operates out of secure, climate-controlled warehouse facilities. Unlike brokers, we handle your move from start to finish with our own fleet of trucks and skilled team, ensuring seamless service every step of the way. A satisfied customer is at the heart of our mission, and we strive for excellence in every move we make.";
const paragraph2 = isLocal
    ? "Fully insured, bonded, and licensed, Navy Seals Moving operates secure, climate-controlled facilities and handles each move directly with our dedicated team and fleet, ensuring quality and care every step of the way. Each year, we proudly serve nearly 3,000 clients across the Northwest, establishing our reputation as a trusted provider for both local and long-distance moves. From standard moving solutions to our finest white-glove options, we are dedicated to exceeding expectations with every move. With all necessary licenses and credentials, Navy Seals Moving provides the expertise and peace of mind you need, no matter the distance."
    : "Navy Seals Moving has grown to become one of the premier luxury and standard moving companies in the Northwest. Since our humble beginnings in the early 2000s, we have earned a reputation as one of the most prestigious names in the moving industry. Today, we assist nearly 3,000 clients annually, consistently delivering exceptional results. Whether you choose our standard moving package or our finest white-glove service, we are committed to impressing and exceeding expectations. For your peace of mind, we hold all necessary licenses and credentials, allowing you to trust us with your move confidently.";

const photos = [
    { src: '/assets/images/about.jpg', alt: 'Navy Seals Moving truck and trailer' },
    { src: '/assets/images/header-crew.jpg', alt: 'Navy Seals Moving crew member wrapping furniture overlooking Seattle', portrait: true },
    { src: '/assets/images/header-rainier.jpg', alt: 'Navy Seals Moving truck with Mount Rainier in the background' },
    { src: '/assets/images/about-photo-5.jpg', alt: 'Navy Seals Moving crew member with carefully wrapped and labeled furniture', portrait: true },
    { src: '/assets/images/header-warehouse.jpg', alt: 'Navy Seals Moving truck at the warehouse in Puyallup' },
];

const Aboutpage = () => {
    const { search } = useLocation();

    return(
        <Fragment>
            <Seo
              title="About Navy Seals Moving | Family-Owned Movers, 20+ Years"
              description="Navy Seals Moving is a family-owned, fully licensed, bonded and insured moving company trusted by nearly 3,000 families a year, premium white-glove service and secure, climate-controlled storage."
            />

            <LayoutOne>

                <PageHeader
                    bgImg={(process.env.PUBLIC_URL + '/assets/images/page_bg.jpg')}
                    title="About Us"
                />

                <section className="about-section" id="about">
                    <div className="container">
                        <div className="row">
                            {/* Left: Welcome + Services text */}
                            <div className="col-md-7 col-sm-12 about_bottom_warp">
                                <div className="about_list">
                                    <SectionTitle title="Welcome to Navy Seals Moving " />
                                    <p>{paragraph1}</p>
                                    <p>{paragraph2}</p>
                                </div>
                                <div className="about-page-services">
                                    <SectionTitle title="Our Services" />
                                    {services.map(service => (
                                        <ChooseUsList
                                            key={service.id}
                                            title={service.title}
                                            text={service.text}
                                            icon={service.icon}
                                        />
                                    ))}
                                </div>

                                {/* Our story timeline */}
                                <div className="about-story">
                                    <SectionTitle title="Our Story" />
                                    <ul className="story-timeline">
                                        <li>
                                            <h6>Early 2000s: Where It All Began</h6>
                                            <p>Navy Seals Moving begins as a small, family-owned moving company in Washington State. From day one, the company is built around a simple standard: treat every customer's home and belongings as if they were our own.</p>
                                        </li>
                                        <li>
                                            <h6>Building It Right</h6>
                                            <p>We open our first warehouse in Kent, Washington: roughly 20,000 square feet. Instead of taking shortcuts, we build the company the right way, with our own trucks, our own professional crews, and direct responsibility for every customer's move.</p>
                                        </li>
                                        <li>
                                            <h6>2015: Growing Into Puyallup</h6>
                                            <p>As our reputation and customer base grow, so does the operation. We expand from the original Kent location into a 100,000-square-foot facility in Puyallup, Washington, with the space and infrastructure to serve more families and handle larger moves.</p>
                                        </li>
                                        <li>
                                            <h6>Going Nationwide</h6>
                                            <p>What started as a small Washington moving company grows into a nationwide operation: families relocating from Washington to destinations across the United States, supported by our fleet, our experienced crews, and our network of distribution facilities.</p>
                                        </li>
                                        <li>
                                            <h6>Today</h6>
                                            <p>Nearly 3,000 moves a year, from local Washington relocations to coast-to-coast moves, and a perfect 5.0 on Google. More than 20 years in, the company is bigger, but the standard hasn't changed: treat every home like our own, treat every customer like family, and take responsibility for every move from beginning to end.</p>
                                        </li>
                                    </ul>

                                    <div className="about-cta">
                                        <p className="about-cta-lead">Ready to plan your move?</p>
                                        <a className="btn btn-chos" href="tel:2066366961">Call (206) 636-6961</a>
                                        <Link
                                            className="btn btn-chos about-cta-quote"
                                            to={{ pathname: process.env.PUBLIC_URL + "/", search: search, hash: "#quote" }}
                                        >
                                            Get Your Free Quote
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* Right: company photos, stacked */}
                            <div className="col-md-5 col-sm-12">
                                <div className="about-photos">
                                    {photos.map((photo, i) => (
                                        <img
                                            key={i}
                                            src={process.env.PUBLIC_URL + photo.src}
                                            alt={photo.alt}
                                            className={photo.portrait ? 'portrait' : undefined}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </LayoutOne>
        </Fragment>

    );
};

export default Aboutpage;
